import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, Switch } from 'react-router-dom';
import { Tabs } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { translate } from 'react-i18next';
import i18next from 'i18next';
import { isEqual, get } from 'lodash';
import moment from 'moment';

import HeadMetas from '../../../../../common/HeadMetasContainer';
import TicketsDetailsForm from '../components/TicketsDetailsFormContainer.js'
import SurveyAttemptFrom from '../../../../../participant/components/CreateSurveyAttemptFormContainer.js'
//import Plugin from '../../../../Plugin';

import { isDateBeforeCurrentDate } from '../../../../../parts/common/dateUtils';
//import { isPluginActive } from '../../../../pluginActions';

import {
  TICKETS_SALE_WIZARD_DETAILS,
  TICKETS_SALE_WIZARD_PAYMENT,
  TICKETS_SALE_WIZARD_CONFIRMATION,
  TICKETS_SALE_WIZARD_SURVEY
} from '../../eventUtils';

import PaymentForm from '../components/TicketsPaymentFormContainer';
import ConfirmationPanel from '../components/TicketsConfirmationPanelContainer';
import AvatarThumbnail from '../../../../../common/AvatarThumbnailContainer';
import HelpText from '../../../../../common/HelpText';
import FundkyButton from '../../../../../parts/ui/components/FundkyButton';
import FundkyModal from '../../../../../parts/ui/components/FundkyModal';

import BuyTicketsPage_en from './locales/BuyTicketsPage_en.json';
import BuyTicketsPage_fr from './locales/BuyTicketsPage_fr.json';

import './BuyTicketsPage.less';

const { TabPane } = Tabs;

class BuyTicketsPage extends React.PureComponent {
  constructor(props) {
    super(props);

    props.fetchCountries();
    props.fetchProvinces();

    let addedOn = get(props, 'reserve.results[0].addedOn', null);
    let exprireOn = get(props, 'reserve.results[0].expireOn', null);
    let max = 10 * 60 * 1000;
    this.started = addedOn && moment(addedOn) || moment();
    this.timeLimit = (addedOn && exprireOn) && moment(exprireOn) - moment(addedOn) || max;
    this.timeLimit = this.timeLimit > max ? max : this.timeLimit;

    this.state = {
      cancel: false,
      timer: moment(this.timeLimit).format('m:ss')
    };

    this.modalRef = React.createRef();

    // TODO Don't use location.state to know where we come from: when navigate back and come back to this page, the info is lost --> use react-router-last-location instead
    // No need to put it in the state because it is immutable
    this.from = props.location.state && props.location.state.from;

    i18next.addResourceBundle('en', 'BuyTicketsPage', BuyTicketsPage_en);
    i18next.addResourceBundle('fr', 'BuyTicketsPage', BuyTicketsPage_fr);
  }

  componentDidMount = async() => {
    this.props.activateCreationMode();
    await this.props.fetchPlatformIdBySurveyList(this.props.platform.id, this.props.campaign.id, [], "purchase-tickets-form", this.props.locale)
    let interval = 100;
    this.interval = setInterval(() => {
      let now = moment();
      let passed = now - this.started;
      let remaining = this.timeLimit - passed;
      let formattedTime = remaining > 0
        ? moment(remaining).format('m:ss')
        : '0:00';
      this.setState({
        timer: formattedTime
      });
      if (remaining <= 0 && this.interval) {
        clearInterval(this.interval);
        this.interval = null;
        this.modalRef.current.getWrappedInstance('FundkyModal').showModal();
      }
    }, interval);
  }

  componentWillUnmount() {
    const
      { props } = this,
      { t, history } = props;

    if(this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }

    const nextLocation = (history && history.location && history.location.pathname) || null;
    const baseUrl = this.getBaseUrl(false);

    if (
      !nextLocation.includes(`${baseUrl}/${t('URL:ticket-purchase/details')}`) &&
      !nextLocation.includes(`${baseUrl}/${t('URL:ticket-purchase/survey')}`) &&
      !nextLocation.includes(`${baseUrl}/${t('URL:ticket-purchase/payment')}`) &&
      !nextLocation.includes(`${baseUrl}/${t('URL:ticket-purchase/confirmation')}`)
    ) {
      this.props.deactivateCreationMode();
      this.props.clearPurchase();
    }
  }

  componentDidUpdate = async (prevProps) => {
    let ticketsIds = this.props.ticketSelection && this.props.ticketSelection.tickets && this.props.ticketSelection.tickets.map(s=>s.ticket.id);
    if (prevProps.campaign !== this.props.campaign && this.props.campaign.id !== undefined) {
      await this.props.fetchPlatformIdBySurveyList(this.props.platform.id, this.props.campaign.id, ticketsIds, "purchase-tickets-form", this.props.locale)
    }
    const badge = document.getElementsByClassName("grecaptcha-badge")[0];
    if (badge && badge.classList && badge.classList.contains("show")) {
      badge.classList.remove("show");
    }
    const activeKey = this.getActiveKey();
    if (activeKey === TICKETS_SALE_WIZARD_CONFIRMATION && this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  getPageType = () => {
    const { match } = this.props;
    const { params } = match;
    return params.teamAlias
      ? 'team'
      : params.campaignAlias
        ? 'campaign'
        : null;
  };

  getBaseUrl = (withLocale = true) => {
    const pageType = this.getPageType();
    const { locale, match } = this.props;
    const { params } = match;

    const localeUrl = withLocale ? `/${locale}` : '';

    switch (pageType) {
      case 'team':
        return `${localeUrl}/${params.campaignAlias}/${params.teamAlias}`;
      case 'campaign':
      default:
        return `${localeUrl}/${params.campaignAlias}`;
    }
  };

  getActiveKey = () => {
    const { location, history, t, currentStep, checkout } = this.props;
    const baseUrl = this.getBaseUrl();

    if (
      (
        get(checkout, 'checkout.transactionStatus') ||
        get(checkout, 'transaction.status')
      ) &&
      currentStep === TICKETS_SALE_WIZARD_CONFIRMATION &&
      !location.pathname.includes(t('URL:ticket-purchase/confirmation'))
    ) {
      switch (get(checkout, 'checkout.transactionStatus', get(checkout, 'transaction.status', ''))) {
        case 'APPROVED':
          history.push(`${baseUrl}/${t('URL:ticket-purchase/confirmation/success')}`);
          break;

        case 'DECLINED':
          history.push(`${baseUrl}/${t('URL:ticket-purchase/confirmation/failed')}`);
          break;

        case 'PENDING':
          //history.push(`${baseUrl}/${t('URL:ticket-purchase/confirmation/pending')}`);
          break;
      }
    }

    if (location.pathname.includes(t('URL:ticket-purchase/details'))) {
      return TICKETS_SALE_WIZARD_DETAILS;
    } else if (location.pathname.includes(t('URL:ticket-purchase/survey'))) {
      return TICKETS_SALE_WIZARD_SURVEY;
    } else if (location.pathname.includes(t('URL:ticket-purchase/payment'))) {
      return TICKETS_SALE_WIZARD_PAYMENT;
    } else if (location.pathname.includes(t('URL:ticket-purchase/confirmation'))) {
      return TICKETS_SALE_WIZARD_CONFIRMATION;
    } else {
      return null;
    }
  };

  handleTabChange = (activeKey, cancel = false) => {
    const { history, t, checkout } = this.props;
    const baseUrl = this.getBaseUrl();

    this.setState({
      cancel
    });

    if (activeKey === TICKETS_SALE_WIZARD_DETAILS) {
      history.push(`${baseUrl}/${t('URL:ticket-purchase/details')}`);
    } else if (activeKey === TICKETS_SALE_WIZARD_SURVEY) {
      history.push(`${baseUrl}/${t('URL:ticket-purchase/survey')}`);
    } else if (activeKey === TICKETS_SALE_WIZARD_PAYMENT) {
      history.push(`${baseUrl}/${t('URL:ticket-purchase/payment')}`);
    } else if (activeKey === TICKETS_SALE_WIZARD_CONFIRMATION) {
      if (cancel) {
        history.push(`${baseUrl}/${t('URL:ticket-purchase/confirmation/cancelled')}`);
      } else {
        switch (get(checkout, 'checkout.transactionStatus', get(checkout, 'transaction.status', ''))) {
          case 'APPROVED':
            history.push(`${baseUrl}/${t('URL:ticket-purchase/confirmation/success')}`);
            break;

          case 'DECLINED':
            history.push(`${baseUrl}/${t('URL:ticket-purchase/confirmation/failed')}`);
            break;

          case 'PENDING':
            //history.push(`${baseUrl}/${t('URL:ticket-purchase/confirmation/pending')}`);
            break;
        }
      }
    }
  };

  handleBackClick = back => {
    this.handleTabChange(back);
  };

  handleCancelClick = () => {
    this.props.cancelTransaction();
    this.handleTabChange(TICKETS_SALE_WIZARD_CONFIRMATION, true);
  };

  handleAcceptModal = () => {
    //this.modalRef.current.getWrappedInstance('FundkyModal').hideModal();
    this.props.history.push(
      `/${this.props.locale}/${this.props.campaign.alias}/${this.props.t('URL:ticket-purchase/choose')}`
    );
  };

  handleCloseModal = () => {
    this.props.history.push(
      `/${this.props.locale}/${this.props.campaign.alias}`
    );
  };

  render() {
    const
      { props, state, getActiveKey, getBaseUrl, handleAcceptModal, handleCloseModal } = this,
      {
        t,
        locale,
        ticketSelection,
        userTypeId,
        eventEndOn,
        history
      } = props,
      { timer } = state;
    const activeKey = getActiveKey();
    const baseUrl = getBaseUrl();

    const ppfProps = {ppf: true, ...props}

    // Redirect to Event page
    if (
      // After event end
      // eventEndOn && isDateBeforeCurrentDate(eventEndOn, true) ||
      // No ticket list
      !ticketSelection ||
      // No tickets in the list
      !ticketSelection.tickets.length ||
      // Not connected after Details step
      activeKey !== TICKETS_SALE_WIZARD_DETAILS && userTypeId !== 2 ||
      // A recipient has been provided, but it is not in the store yet.
      !activeKey && !this.state.cancel
    )
      return <Redirect to={`${baseUrl}`} />;

    // Hide Payment tab when total ammount is 0 (Event tickets)
    let hidePaymentTab = false;
    if (ticketSelection && Array.isArray(ticketSelection.tickets)) {
      let total = 0;
      // TODO: add combined donation/purchase to total too
      for (let i = 0; i < ticketSelection.tickets.length; i++) {
        if (ticketSelection.tickets[i].totalPrice)
          total += ticketSelection.tickets[i].totalPrice;
      }
      if (!total) hidePaymentTab = true;
    }

    // A recipient has been provided, but it is not in the store yet.
    let type, entity;
    if ((entity = ticketSelection.campaign)) {
      type = 'campaign';
    } else if ((entity = ticketSelection.team)) {
      type = 'team';
    }

    if (!entity)
      return null;

    const recipientInfo = entity ? (
      <div className="BuyTicketsPage__Divider BuyTicketsPage__Divider--title BuyTicketsPage__Header FundkyWrap">
        <AvatarThumbnail
          entity={entity}
          primaryContent={entity.name || (entity.member && entity.member.name) || ''}
          secondaryContent={<HelpText>{t('event')}</HelpText>}
          className="AvatarThumbnail--title"
          avatarSize={127}
        />
        {activeKey !== TICKETS_SALE_WIZARD_CONFIRMATION &&
          <>
            <div className="BuyTicketsPage__Timer">{timer}</div>
            <FundkyModal
              ref={this.modalRef}
              className="BuyTicketsPage__Modal"
              displayModal={false}
              displayCancel={false}
              acceptLabel={t('times-up-btn')}
              acceptAction={handleAcceptModal}
              cancelAction={handleCloseModal}
              title={t('times-up-title')}
            >
              <p>{t('times-up-desc')}</p>
            </FundkyModal>
          </>
          || null
        }
      </div>
    ) : null;

    const routes = [
      { path: `/${locale}/:campaignAlias` },
      { path: `/${locale}/:campaignAlias/:teamAlias` }
    ];
    let hideSurveyTab = this.props.surveyId ? false : true;
    return (
      <div className="BuyTicketsPage">
        <HeadMetas title={t('make-a-donation.title')} />
        {recipientInfo}
        <Tabs className="FillActive" activeKey={activeKey} onChange={this.handleTabChange}>
          <TabPane
            tab={
              <span>
                {t('information')}{' '}
                {activeKey !== TICKETS_SALE_WIZARD_DETAILS &&
                  !this.state.cancel && <FontAwesomeIcon icon={['fas', 'check']} />}
              </span>
            }
            disabled={
              activeKey === TICKETS_SALE_WIZARD_CONFIRMATION
            }
            key={TICKETS_SALE_WIZARD_DETAILS}
          >
            <Switch>
              {routes.map((route, index) => (
                <Route
                  key={index}
                  path={`${route.path}/${t('URL:ticket-purchase/details')}`}
                  render={props => (
                    <TicketsDetailsForm
                      {...props}
                      from={this.from}
                      handleTabChange={this.handleTabChange}
                      handleCancelClick={this.handleCancelClick}
                      history={history}
                      baseUrl={baseUrl}
                      isLeader={this.isLeader}
                    />
                  )}
                />
              ))}
            </Switch>
          </TabPane>
          {!hideSurveyTab && (
            <TabPane
              tab={
                <span>
                  {t('survey')}
                  {activeKey !== TICKETS_SALE_WIZARD_DETAILS && activeKey !== TICKETS_SALE_WIZARD_SURVEY && !this.state.cancel && (
                    <FontAwesomeIcon icon={['fas', 'check']} />
                  )}
                </span>
              }
              disabled={ activeKey !== TICKETS_SALE_WIZARD_SURVEY }
              key={TICKETS_SALE_WIZARD_SURVEY}
            >
              <Switch>
                {routes.map((route, index) => (
                  <Route
                    key={index}
                    path={`${route.path}/${t('URL:ticket-purchase/survey')}`}
                    render={(props) => (
                      <SurveyAttemptFrom {...props} handleBackClick={this.handleBackClick} />
                    )}
                  />
                ))}
              </Switch>
            </TabPane>
          )}
          {!hidePaymentTab &&
          <TabPane
            tab={
              <span>
                {`${t('payment')} `}
                {activeKey === TICKETS_SALE_WIZARD_PAYMENT && !this.state.cancel && (
                  <FontAwesomeIcon icon={['fas', 'check']} />
                )}
              </span>
            }
            disabled={ activeKey !== TICKETS_SALE_WIZARD_PAYMENT }
            key={TICKETS_SALE_WIZARD_PAYMENT}
          >
            <Switch>
              {routes.map((route, index) => (
                <Route
                  key={index}
                  path={`${route.path}/${t('URL:ticket-purchase/payment')}`}
                  render={props => (
                    <PaymentForm
                      {...ppfProps}
                      from={this.from}
                      handleTabChange={this.handleTabChange}
                      handleBackClick={this.handleBackClick}
                      handleCancelClick={this.handleCancelClick}
                      target={entity || null}
                    />
                  )}
                />
              ))}
            </Switch>
          </TabPane>
          }
          <TabPane
            tab={<span>{t('confirmation')}</span>}
            disabled={activeKey !== TICKETS_SALE_WIZARD_CONFIRMATION}
            key={TICKETS_SALE_WIZARD_CONFIRMATION}
          >
            <Switch>
              {routes.map((route, index) => (
                <Route
                  key={index}
                  path={`${route.path}/${t('URL:ticket-purchase/confirmation')}`}
                  render={props => (
                    <ConfirmationPanel
                      {...props}
                      from={this.from}
                      entity={entity}
                      type={type}
                      handleTabChange={this.handleTabChange}
                      cancel={this.state.cancel}
                    />
                  )}
                />
              ))}
            </Switch>
          </TabPane>
        </Tabs>
      </div>
    );
  }
}

BuyTicketsPage.propTypes = {
  location: PropTypes.object,
  currentStep: PropTypes.oneOf([
    TICKETS_SALE_WIZARD_DETAILS,
    TICKETS_SALE_WIZARD_PAYMENT,
    TICKETS_SALE_WIZARD_CONFIRMATION
  ])
};

export default translate('BuyTicketsPage')(BuyTicketsPage);
